module.exports = fox._r("images/slides/urban/slide_3_3.jpg", __webpack_public_path__ + "images/slides/urban/slide_3_3.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_3_3.jpg
// module id = 62
// module chunks = 2